import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  initActiveProduct,
  getCurrentSelection,
  changeProduct,
  clearSelection,
  moveNodeToHome,
} from '../modules/player';
import {
  getActiveProduct,
  getProducts,
  setActiveProduct,
} from '../modules/products';
import SelectionInfo from './SelectionInfo';
import Thumbnail from './Thumbnail';
import Swatches from './Swatches';
import ClearSelection from './ClearSelection';

const PlayerContainer = styled.div`
  width: 100%;
  height: 450px;
`;

const Container = styled.div`
  width: 100%;
  // display: block;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
`;

const SubContainer = styled.div`
  width: 100%;
  display: block;
`;

const SwatchesContainer = styled.div`
  width: 70%;
  margin: auto;
`;
const WrapperContainer = styled.div`
  width: 70%;
  position: relative;
`;
const LeftArrow = styled.img`
  position: absolute;
  left: 4%;
  top: 35%;
  width: 30px;
  height: 30px;
  opacity: 0.7;
  cursor: pointer;
`;

const RightArrow = styled.img`
  position: absolute;
  cursor: pointer;
  right: 5%;
  top: 35%;
  width: 30px;
  height: 30px;
  opacity: 0.7;
`;

class Player extends PureComponent {
  setActiveProduct(idx, value) {
    const { changeProduct } = this.props;
    changeProduct(value);
  }

  componentDidMount() {
    const { initActiveProduct, initConfig } = this.props;
    initActiveProduct(initConfig);
  }

  render() {
    const {
      currentSelection,
      showPresets,
      active,
      products,
      clearSelection,
      moveNodeToHome,
    } = this.props;
    const images = Object.keys(products).map(preset => ({
      value: preset,
      key: preset,
      url: `/img/${preset.replace('/', '')}.png`,
    }));
    return (
      <WrapperContainer>
        <SubContainer>
          <PlayerContainer id="clara" />
          {showPresets ? (
            <SwatchesContainer>
              <Swatches
                col={5}
                images={images}
                activeArrow={true}
                active={active.name}
                onClick={this.setActiveProduct.bind(this)}
                moveNodeToHome={moveNodeToHome}
              />
            </SwatchesContainer>
          ) : (
            <div>
              <SelectionInfo currentSelection={currentSelection} />
              <ClearSelection
                moveNodeToHome={moveNodeToHome}
                clearSelection={clearSelection}
              />
            </div>
          )}
        </SubContainer>
      </WrapperContainer>
    );
  }
}

class SelectProduct extends PureComponent {
  setActiveProduct(idx, value) {
    const { products, setActiveProduct } = this.props;
    if (value) return setActiveProduct(value);
    if (idx < 0 || idx >= Object.keys(products).length) return;
    setActiveProduct(Object.keys(products)[idx]);
  }

  render() {
    const { active, products } = this.props;
    const images = Object.keys(products).map(preset => ({
      value: preset,
      key: preset,
      url: `/img/${preset.replace('/', '')}.png`,
    }));
    const activeIdx = Object.keys(products).indexOf(active.name);
    const activeThumb = images.find(item => item.value === active.name);
    return (
      <WrapperContainer>
        <Container>
          <Thumbnail url={activeThumb.url} />
          <LeftArrow
            onClick={e => this.setActiveProduct(activeIdx - 1)}
            src="https://upload.wikimedia.org/wikipedia/commons/8/8e/MediaWiki_Vector_skin_left_arrow.svg"
          />
          <RightArrow
            onClick={e => this.setActiveProduct(activeIdx + 1)}
            src="https://upload.wikimedia.org/wikipedia/commons/0/03/MediaWiki_Vector_skin_right_arrow.svg"
          />
          <SwatchesContainer>
            <Swatches
              col={5}
              images={images}
              activeArrow={true}
              active={active.name}
              onClick={this.setActiveProduct.bind(this)}
            />
          </SwatchesContainer>
        </Container>
      </WrapperContainer>
    );
  }
}

class PlayerOrThumbnail extends PureComponent {
  render() {
    const props = this.props;
    const initialized = props.initialized;
    return initialized ? <Player {...props} /> : <SelectProduct {...props} />;
  }
}

const mapStateToProps = state => ({
  currentSelection: getCurrentSelection(state),
  products: getProducts(state),
  active: getActiveProduct(state),
  initialized: state.player.initialized,
  showPresets: state.player.showPresets,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      initActiveProduct,
      setActiveProduct,
      changeProduct,
      clearSelection,
      moveNodeToHome,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerOrThumbnail);



// WEBPACK FOOTER //
// ./src/components/Player.js